import { UnitV2 } from '@cemex-core/cmx-api';
import { ProductUnitActions, ProductUnitActionTypes } from '../../actions/product-unit.actions';
import { AltUnit } from '../../models/units';

export interface State {
  productUnits: {
    [productId: number]: UnitV2[];
  };
  alternativeUnits: {
    [productId: number]: AltUnit[];
  };

  actualUnits: UnitV2[]; // Unused. Let's delete this?
}

export const initialState: State = {
  productUnits: {},
  alternativeUnits: {},
  actualUnits: [],
};

export function reducer(state = initialState, action: ProductUnitActions): State {
  switch (action.type) {
    case ProductUnitActionTypes.LOAD_UNITS_COMPLETE: {
      return {
        ...state,
        productUnits: {
          ...state.productUnits,
          ...action.payload,
        },
      } as State;
    }
    case ProductUnitActionTypes.LOAD_ALTERNATIVE_UNITS_COMPLETE: {
      return {
        ...state,
        alternativeUnits: {
          ...state.alternativeUnits,
          ...action.payload,
        },
      } as State;
    }
    default: {
      return state;
    }
  }
}
